var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnotherScheduledActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.924 4.63036H10.996L10.646 11.1824H9.26L8.924 4.63036ZM9.96 14.5284C9.63333 14.5284 9.36267 14.4257 9.148 14.2204C8.93333 14.0057 8.826 13.7444 8.826 13.4364C8.826 13.1284 8.93333 12.8717 9.148 12.6664C9.36267 12.461 9.63333 12.3584 9.96 12.3584C10.2773 12.3584 10.5387 12.461 10.744 12.6664C10.9587 12.8717 11.066 13.1284 11.066 13.4364C11.066 13.7444 10.9587 14.0057 10.744 14.2204C10.5387 14.4257 10.2773 14.5284 9.96 14.5284Z",
    fill: "#DC7E16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnotherScheduledActivity);
export default __webpack_public_path__ + "static/media/AnotherScheduledActivity.f1c1ba32610f720d835fd5b7a26a442c.svg";
export { ForwardRef as ReactComponent };